import React from "react";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }
  
  50% {
    opacity: 0.5
  }
  
  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
`;

const Row = () => (
  <SVG
    width="736"
    height="44"
    viewBox="0 0 736 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_9679_72726" fill="white">
      <path d="M659.111 0H736V44H659.111V0Z" />
    </mask>
    <path d="M659.111 0H736V44H659.111V0Z" fill="white" />
    <rect
      x="671.111"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M736 43H659.111V45H736V43Z"
      fill="#D6E3F0"
      mask="url(#path-1-inside-1_9679_72726)"
    />
    <mask id="path-4-inside-2_9679_72726" fill="white">
      <path d="M582.222 0H659.111V44H582.222V0Z" />
    </mask>
    <path d="M582.222 0H659.111V44H582.222V0Z" fill="white" />
    <rect
      x="594.222"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M659.111 43H582.222V45H659.111V43Z"
      fill="#D6E3F0"
      mask="url(#path-4-inside-2_9679_72726)"
    />
    <mask id="path-7-inside-3_9679_72726" fill="white">
      <path d="M505.333 0H582.222V44H505.333V0Z" />
    </mask>
    <path d="M505.333 0H582.222V44H505.333V0Z" fill="white" />
    <rect
      x="517.333"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M582.222 43H505.333V45H582.222V43Z"
      fill="#D6E3F0"
      mask="url(#path-7-inside-3_9679_72726)"
    />
    <mask id="path-10-inside-4_9679_72726" fill="white">
      <path d="M428.444 0H505.333V44H428.444V0Z" />
    </mask>
    <path d="M428.444 0H505.333V44H428.444V0Z" fill="white" />
    <rect
      x="440.444"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M505.333 43H428.444V45H505.333V43Z"
      fill="#D6E3F0"
      mask="url(#path-10-inside-4_9679_72726)"
    />
    <mask id="path-13-inside-5_9679_72726" fill="white">
      <path d="M351.556 0H428.444V44H351.556V0Z" />
    </mask>
    <path d="M351.556 0H428.444V44H351.556V0Z" fill="white" />
    <rect
      x="363.556"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M428.444 43H351.556V45H428.444V43Z"
      fill="#D6E3F0"
      mask="url(#path-13-inside-5_9679_72726)"
    />
    <mask id="path-16-inside-6_9679_72726" fill="white">
      <path d="M274.667 0H351.556V44H274.667V0Z" />
    </mask>
    <path d="M274.667 0H351.556V44H274.667V0Z" fill="white" />
    <rect
      x="286.667"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M351.556 43H274.667V45H351.556V43Z"
      fill="#D6E3F0"
      mask="url(#path-16-inside-6_9679_72726)"
    />
    <mask id="path-19-inside-7_9679_72726" fill="white">
      <path d="M197.778 0H274.667V44H197.778V0Z" />
    </mask>
    <path d="M197.778 0H274.667V44H197.778V0Z" fill="white" />
    <rect
      x="209.778"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M274.667 43H197.778V45H274.667V43Z"
      fill="#D6E3F0"
      mask="url(#path-19-inside-7_9679_72726)"
    />
    <mask id="path-22-inside-8_9679_72726" fill="white">
      <path d="M120.889 0H197.778V44H120.889V0Z" />
    </mask>
    <path d="M120.889 0H197.778V44H120.889V0Z" fill="white" />
    <rect
      x="132.889"
      y="16"
      width="52.8889"
      height="12"
      rx="1"
      fill="#E9EFF5"
    />
    <path
      d="M197.778 43H120.889V45H197.778V43Z"
      fill="#D6E3F0"
      mask="url(#path-22-inside-8_9679_72726)"
    />
    <mask id="path-25-inside-9_9679_72726" fill="white">
      <path d="M44 0H120.889V44H44V0Z" />
    </mask>
    <path d="M44 0H120.889V44H44V0Z" fill="white" />
    <rect x="56" y="16" width="52.8889" height="12" rx="1" fill="#E9EFF5" />
    <path
      d="M120.889 43H44V45H120.889V43Z"
      fill="#D6E3F0"
      mask="url(#path-25-inside-9_9679_72726)"
    />
    <mask id="path-28-inside-10_9679_72726" fill="white">
      <path d="M0 0H44V44H0V0Z" />
    </mask>
    <path d="M0 0H44V44H0V0Z" fill="white" />
    <rect x="12" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
    <path
      d="M44 43H0V45H44V43Z"
      fill="#D6E3F0"
      mask="url(#path-28-inside-10_9679_72726)"
    />
  </SVG>
);

const ProbablesModuleLoading = () => (
  <>
    <SVG
      width="736"
      height="44"
      viewBox="0 0 736 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_9679_72704" fill="white">
        <path d="M0 0H44V44H0V0Z" />
      </mask>
      <path d="M0 0H44V44H0V0Z" fill="white" />
      <path
        d="M44 43H0V45H44V43Z"
        fill="#D6E3F0"
        mask="url(#path-1-inside-1_9679_72704)"
      />
      <mask id="path-3-inside-2_9679_72704" fill="white">
        <path d="M44 0H120.889V44H44V0Z" />
      </mask>
      <path d="M44 0H120.889V44H44V0Z" fill="white" />
      <rect x="88.8889" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M120.889 43H44V45H120.889V43Z"
        fill="#D6E3F0"
        mask="url(#path-3-inside-2_9679_72704)"
      />
      <mask id="path-6-inside-3_9679_72704" fill="white">
        <path d="M120.889 0H197.778V44H120.889V0Z" />
      </mask>
      <path d="M120.889 0H197.778V44H120.889V0Z" fill="white" />
      <rect x="165.778" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M197.778 43H120.889V45H197.778V43Z"
        fill="#D6E3F0"
        mask="url(#path-6-inside-3_9679_72704)"
      />
      <mask id="path-9-inside-4_9679_72704" fill="white">
        <path d="M197.778 0H274.667V44H197.778V0Z" />
      </mask>
      <path d="M197.778 0H274.667V44H197.778V0Z" fill="white" />
      <rect x="242.667" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M274.667 43H197.778V45H274.667V43Z"
        fill="#D6E3F0"
        mask="url(#path-9-inside-4_9679_72704)"
      />
      <mask id="path-12-inside-5_9679_72704" fill="white">
        <path d="M274.667 0H351.556V44H274.667V0Z" />
      </mask>
      <path d="M274.667 0H351.556V44H274.667V0Z" fill="white" />
      <rect x="319.556" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M351.556 43H274.667V45H351.556V43Z"
        fill="#D6E3F0"
        mask="url(#path-12-inside-5_9679_72704)"
      />
      <mask id="path-15-inside-6_9679_72704" fill="white">
        <path d="M351.556 0H428.444V44H351.556V0Z" />
      </mask>
      <path d="M351.556 0H428.444V44H351.556V0Z" fill="white" />
      <rect x="396.444" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M428.444 43H351.556V45H428.444V43Z"
        fill="#D6E3F0"
        mask="url(#path-15-inside-6_9679_72704)"
      />
      <mask id="path-18-inside-7_9679_72704" fill="white">
        <path d="M428.444 0H505.333V44H428.444V0Z" />
      </mask>
      <path d="M428.444 0H505.333V44H428.444V0Z" fill="white" />
      <rect x="473.333" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M505.333 43H428.444V45H505.333V43Z"
        fill="#D6E3F0"
        mask="url(#path-18-inside-7_9679_72704)"
      />
      <mask id="path-21-inside-8_9679_72704" fill="white">
        <path d="M505.333 0H582.222V44H505.333V0Z" />
      </mask>
      <path d="M505.333 0H582.222V44H505.333V0Z" fill="white" />
      <rect x="550.222" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M582.222 43H505.333V45H582.222V43Z"
        fill="#D6E3F0"
        mask="url(#path-21-inside-8_9679_72704)"
      />
      <mask id="path-24-inside-9_9679_72704" fill="white">
        <path d="M582.222 0H659.111V44H582.222V0Z" />
      </mask>
      <path d="M582.222 0H659.111V44H582.222V0Z" fill="white" />
      <rect x="627.111" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M659.111 43H582.222V45H659.111V43Z"
        fill="#D6E3F0"
        mask="url(#path-24-inside-9_9679_72704)"
      />
      <mask id="path-27-inside-10_9679_72704" fill="white">
        <path d="M659.111 0H736V44H659.111V0Z" />
      </mask>
      <path d="M659.111 0H736V44H659.111V0Z" fill="white" />
      <rect x="704" y="12" width="20" height="20" rx="1" fill="#E9EFF5" />
      <path
        d="M736 43H659.111V45H736V43Z"
        fill="#D6E3F0"
        mask="url(#path-27-inside-10_9679_72704)"
      />
    </SVG>

    {[...Array(7)].map((_, i) => (
      <Row key={i.toString()} />
    ))}
  </>
);

export default React.memo(ProbablesModuleLoading);
